import { apiClient, ApiResponse } from "./apiClient";
import { AuthType } from "../models/enums";
import { logger } from "../Services/LoggingService";
import { IRpgClass } from "../models/IRpgClass";
import { IRpgRace } from "../models/IRpgRace";
import { IRpgCharacter } from "../models/IRpgCharacter";
import { ISaveCharacter } from "../models/ISaveCharacter";
import { IRpgAlignment } from "../models/IRpgAlignment";

class CharacterAPI {
    getAlignments = async () => {
        let response: IRpgAlignment[] = [];

        await apiClient("Character/GetAlignments", { method: "GET" }, AuthType.Basic)
            .then((ret: ApiResponse) => {
                if (!hasErrors(ret)) {
                    return response = ret.response as unknown as IRpgAlignment[];
                }
            })
            .catch((err) => {handleErrors(err)});

        return response;
    }

    getChars = async (userId: number) => {
        let response: IRpgCharacter[] = [];

        await apiClient("Character/GetCharacters/" + userId, { method: "Get"}, AuthType.Basic)
            .then((ret: ApiResponse) => {
                //logger.info("charAPI getChars results", ret);
                if (!hasErrors(ret)) {
                    return response = ret.response as unknown as IRpgCharacter[];
                }
            })
            .catch((err) => {handleErrors(err)});

        return response;
    };

    getClasses = async () => {
        let response: IRpgClass[] = [];

        await apiClient("Character/GetClasses", { method: "GET" }, AuthType.Basic)
            .then((ret: ApiResponse) => {
                logger.info("charAPI getClasses results", ret);
                if (!hasErrors(ret)) {
                    return response = ret.response as unknown as IRpgClass[];
                }
            })
            .catch((err) => {handleErrors(err)});

        return response;
    }

    getRaces = async () => {
        let response: IRpgRace[] = [];

        await apiClient("Character/GetRaces", { method: "GET" }, AuthType.Basic)
            .then((ret: ApiResponse) => {
                logger.info("charAPI getRaces results", ret);
                if (!hasErrors(ret)) {
                    return response = ret.response as unknown as IRpgRace[];
                }
            })
            .catch((err) => {handleErrors(err)});

        return response;
    }

    saveChar = async (userId: number, char: ISaveCharacter) => {
        let response = "";

        await apiClient("Character/SaveCharacter/" + userId, { method: "Post", body: JSON.stringify(char) }, AuthType.Basic)
            .then((ret: ApiResponse) => {
                //logger.info("charAPI saveChar results", ret);
                if (!hasErrors(ret)) {
                    response = ret.response as string;
                    return;
                }
            })
            .catch((err) => {
                handleErrors(err);
                response = err.toLocaleString();
            });

        return response;
    };
}

const handleErrors = (err: any) => {
    if (err) {
        logger.warning("" + err);
    } else {
        logger.warning("Error from apiClient in CharacterAPI");
    }
};

const hasErrors = (ret: ApiResponse) => {
    if ((ret.status !== 200) && (ret.status !== 201) && (ret.status !== 202) && (ret.status !== 204)) {
        handleErrors(ret.response)
        return true;
    }
    return false;
};

export const charAPI = new CharacterAPI();
